import React, { useState } from 'react';
import { CSR_PAGE, SEO_META } from '../mock';
import Seo from '../components/Seo';
import { CsrHero, CsrStats } from '../components/csr/CsrHero';
import { CsrCauses } from '../components/csr/CsrCauses';
import { CsrPartner } from '../components/csr/CsrPartner';
import { DonateDialog } from '../components/csr/DonateDialog';

const CsrPage = () => {
  const { hero, stats, causes, partner } = CSR_PAGE;
  const [donateCause, setDonateCause] = useState(null);

  return (
    <main className="bg-ink">
      <Seo {...SEO_META.csr} />
      <CsrHero hero={hero} />
      <CsrStats stats={stats} />
      <CsrCauses causes={causes} onDonate={setDonateCause} />
      <CsrPartner partner={partner} />
      <DonateDialog cause={donateCause} onClose={() => setDonateCause(null)} />
    </main>
  );
};

export default CsrPage;
